export default __webpack_public_path__ + "static/media/defaultProfile.b8428432.svg";